<template>
  <div class="pms-container">
    <div class="menu-nav">
      <sider-bar></sider-bar>
    </div>
    <div class="pms-main-container">
      <pms-main></pms-main>
    </div>
  </div>
</template>

<script>
  import SiderBar from './components/siderbar/index'
  import PmsMain from './components/pmsMain/index'
  export default {
    name: 'PMS',
    components: {
      SiderBar,
      PmsMain
    }
  }
</script>

<style scoped rel="stylesheet/scss" lang="scss">

  .pms-container {
    display: flex;
    flex-grow: 1;
    justify-content: space-between;

    .menu-nav {
      width: 200px;
      min-height: calc(100vh - 200px);
      background-color: white;
      padding-top: 20px;
      border-radius: 4px;
      overflow: auto;
      height: calc(100vh - 160px);
    }
    .pms-main-container {
      /*width: 65vw;*/
      flex-grow: 1;
      margin-left: 30px;
      min-height: calc(100vh - 200px);
      background-color: white;
      border-radius: 4px;
      height: calc(100vh - 140px);
      overflow: auto;
    }
  }
</style>